import React from "react";
import {
  HeroContainer,
  // HeroBg,
  // VideoBg,
  HeroContent,
  HeroH1,
  HeroP,
  // HeroBtnWrapper,
  // ArrowForward,
  // ArrowRight,
} from "./HeroElements";
import { Typewriter } from "react-simple-typewriter";

const HeroSection = () => {
  // const [hover, setHover] = useState(false);

  // const onHover = () => {
  //   setHover(!hover);
  // };

  return (
    <HeroContainer id="home">
      {/* <HeroBg>
        <VideoBg
          autoPlay
          loop
          muted
          defaultMuted
          playsinline="true"
          oncontextmenu="return false;"
          preload="auto"
          src={Video}
          type="video/mp4"
        />
      </HeroBg> */}
      <HeroContent>
        <HeroH1>Hi, I'm Matt!</HeroH1>
        
        <HeroP>
          <Typewriter 
            words={["An Aspiring Software Engineer."]}
            cursor
            typeSpeed={140}
            delaySpeed={1700}
          />
        </HeroP>

        {/* <HeroBtnWrapper>
          <Button
            to="signup"
            onMouseEnter={onHover}
            onMouseLeave={onHover}
            primary="true"
            dark="true"
          >
            Get started {hover ? <ArrowForward /> : <ArrowRight />}
          </Button>
        </HeroBtnWrapper> */}
      </HeroContent>
    </HeroContainer>
  );
};

export default HeroSection;
